<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col-md-3" v-for="{name, slug, component} in affiliateSections" :key="name">
          <a href="javascript:void(0)" class="menu-link text-center text-bold" :class="(slug == currentSectionSlug) ? 'active' : null" @click="selectSection(slug,component)">
            {{ name }}
          </a>
        </div>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-md-12">
        <component :is="currentSection"
          :affiliateID="Number($route.params.id)"
          :affiliate="affiliate"
          :advertiseSizes="advertiseSizes"
          :advertisements="advertisements"
          :affiliate_invoices="affiliate_invoices"
        />
      </div>
    </div>
  </div>

</template>

<script>
import AffiliateBasicDetails from '@/components/Affiliate/AffiliateBasicDetails.vue'
import AffiliateAdvertisement from '@/components/Affiliate/AffiliateAdvertisement.vue'
import AffiliateBookings from '@/components/Affiliate/AffiliateBookings.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'AffiliateEdit',
  computed: {
    ...mapGetters(['getLoadStatus']),
    userRole() {
      return localStorage.getItem("user_role");
    }
  },
  data () {
    return {
      affiliate: null,
      advertiseSizes:[],
      advertisements: [],
      affiliate_invoices:[],
      affiliateSections : [
        {
          name:'Basic Details',
          slug:'basic_details',
          component:'AffiliateBasicDetails'
        },
        {
          name:'Advertisements',
          slug:'advertisements',
          component:'AffiliateAdvertisement'
        },
        {
          name:'Bookings',
          slug:'bookings',
          component:'AffiliateBookings'
        },
      ],
      currentSectionSlug:'advertisements',
      currentSection:'AffiliateAdvertisement'
    }
  },
  components: {
    AffiliateBasicDetails,
    AffiliateAdvertisement,
    AffiliateBookings
  },
  created () {
    this.getAffiliate()
  },
  watch: {
    '$route': 'getAffiliate'
  },
  methods: {
    getAffiliate() {
        this.$store.dispatch('setLoadStatus')
        fetch(this.$api + 'affiliates/' + this.$route.params.id, {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Authorization': localStorage.getItem('token')
            }
        })
            .then(res => res.json())
            .then(response => {
                this.affiliate = response.data.affiliate
                this.advertiseSizes = response.data.advertiseSizes
                this.affiliate_invoices = this.affiliate.payment_invoices
                this.$store.dispatch('setLoadStatus')
            })
    },
    selectSection(slug,comp) {
      this.currentSectionSlug = slug
      this.currentSection = comp
    }
  }
}
</script>
<style>
.menu-link {
  display: block;
  height: 60px;
  padding: 15px 20px;
  border-radius: 5px;
  text-decoration: none;
  color: #000;
  background-color: #fff;
  border: 1px solid #dee2e6;
  font-size: 18px;
  font-weight: bold;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}
.menu-link.active {
  background-color: #fd7e14;
  color: #fff;
  border: 1px solid #fd7e14;
}
</style>